import React from 'react'
import Accordion from 'react-bootstrap/Accordion';

const Faqs = ({datas}) => {
  return (
    <div className='s4-fin-reco f-width m-auto'>
        <div className=''>
            <p className='fs-md'>FAQ's</p>
            <Accordion defaultActiveKey='0' flush>
                {
                    datas.map((data, index) => (
                        <Accordion.Item eventKey={data.id} key={index}>
                            <Accordion.Header><strong className='fs-sm fw-bold'>{ data.head }</strong></Accordion.Header>
                            <Accordion.Body style={{color:"#00000070"}}>{ data.body }</Accordion.Body>
                        </Accordion.Item>
                    )) 
                }
            </Accordion>
        </div>
    </div>
  )
}

export default Faqs